// @comfy/shared — 共享 TypeScript 类型
// 这些类型供 lambda / worker / pwa 复用。
// 定义依据 design.md「Data Models」一节。
/** 合法默认尺寸（宽高均为 16 的倍数）。 */
export const DEFAULT_DIMS = {
    width: 1216,
    height: 832,
};
/** 最近列表的上限（Req 8.5）。 */
export const MAX_RECENT = 20;
//# sourceMappingURL=types.js.map